import { ReachIntegration } from '@reach/interfaces/integrations/integration-type.enum';
import { QuotaStatusItem } from '@reach/interfaces/quotas/quota.responses';
import { QuotaTypeEnum, StandardQuotaTypeEnum } from '@reach/interfaces/quotas/quota-type.enum';

interface QuotaItemsToOverride {
	used: number;
	total: number;
	available: number;
}
export type ReachQuotaStatusItem = Omit<QuotaStatusItem, keyof QuotaItemsToOverride> & {
	percentage: number;
	showWarning: boolean;
} & QuotaItemsToOverride;

export type ReachQuotaStatus = Record<StandardQuotaTypeEnum, ReachQuotaStatusItem> & {
	[QuotaTypeEnum.INTEGRATION_NODES]: Record<ReachIntegration, ReachQuotaStatusItem>;
};
